import {
    Component, OnInit, AfterViewInit, AfterContentChecked, ElementRef, OnDestroy, Input,
    ViewChild, Output, EventEmitter
} from '@angular/core';
import {ImgPerspectiveComponent} from "../components/img-perspective/img-perspective.component";

declare var window, TiltFx, jQuery, TimelineMax, TweenMax, Power2, Sine;

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.less']
})
export class HomeComponent implements OnInit, OnDestroy, AfterViewInit {
    @Output() animOpenSectionEnded: EventEmitter<any> = new EventEmitter();
    @Output() animCloseSectionEnded: EventEmitter<any> = new EventEmitter();

    @ViewChild(ImgPerspectiveComponent) imgPerspectiveComponent: ImgPerspectiveComponent;

    tl_homepage: any;
    animatedElems: any = {};

    isTiltImgActivated: boolean = false;

    constructor(private elRef: ElementRef) {
    }

    ngOnInit() {
        let _this = this;

        this.tl_homepage = new TimelineMax({
            paused: true,
            repeat: 0,
            force3d: true,
            onComplete(){
                _this.animOpenSectionEnded.emit();
            },
            onReverseComplete(){
                // _this.animCloseSectionEnded.emit();
            }
        });
    }

    ngOnDestroy() {
        this.tl_homepage.kill();
        this.tl_homepage = null;
    }

    ngAfterViewInit() {
        this.setupElems();
        this.tl_setUpAnimIntro();

        setTimeout(()=> {
            this.tl_homepage.play();
        }, 10);
    }

    setupElems() {
        this.animatedElems.lineWebDeveloper = jQuery('[line-web-developer]', this.elRef.nativeElement);
        this.animatedElems.titleWebDeveloper = jQuery('[title-web-developer]', this.elRef.nativeElement);
        this.animatedElems.numberWebDeveloper = jQuery('[number-web-developer]', this.elRef.nativeElement);
        this.animatedElems.emailWebDeveloper = jQuery('[email-web-developer]', this.elRef.nativeElement);
        this.animatedElems.blockName = jQuery('[block-name]', this.elRef.nativeElement);

        this.animatedElems.imgComputer = jQuery('[img-computer]', this.elRef.nativeElement);
        this.animatedElems.imgSlideLight = jQuery('[img-slide-light]', this.elRef.nativeElement);
        this.animatedElems.imgSlideLight2 = jQuery('[img-slide-light-2]', this.elRef.nativeElement);
        this.animatedElems.imgSlide = jQuery('[img-slide]', this.elRef.nativeElement);
        this.animatedElems.tiltFxImg = jQuery('.tilt-effect', this.elRef.nativeElement);

        this.animatedElems.imgElem = jQuery('[img-perspective]', this.elRef.nativeElement);
    }

    componentAnimOut() {
        let that = this;

        TweenMax.fromTo(this.imgPerspectiveComponent.animatedElems.imgElem, .4, {autoAlpha: 1}, {
            autoAlpha: 0,
            onComplete(){
                that.isTiltImgActivated = false;
                that.tl_homepage.reverse();
            }
        });

        setTimeout(() => {
            this.animCloseSectionEnded.emit();
        }, 3200);
    }

    tl_setUpAnimIntro() {
        let _this = this;

        // anim | animIn bg img
        this.tl_homepage.fromTo(this.animatedElems.imgComputer, 1.9, {transform: "translateX(150px)"}, {
            transform: "translateX(0px)",
            delay: 1.4,
            ease: Power2.easeOut
        });

        this.tl_homepage.fromTo(this.animatedElems.blockName, 1.2, {
            autoAlpha: 0,
            x: "-30%"
        }, {autoAlpha: 1, x: "-70%", force3d: true});


        // -------------------
        // anim | intro "web developer"
        this.tl_homepage.add("anim_web-developer", 3.2);

        let a_wd_1 = TweenMax.fromTo(this.animatedElems.lineWebDeveloper, 1.7, {transform: "scaleX(0)"}, {
            transform: "scaleX(1)",
            ease: Power2.easeOut
        });
        let a_wd_2 = TweenMax.fromTo(this.animatedElems.titleWebDeveloper, 1.2, {x: "100%"}, {
            x: "0%",
            delay: .7,
            force3d: false,
            ease: Sine.easeOut
        });
        let a_wd_3 = TweenMax.fromTo(this.animatedElems.numberWebDeveloper, 1.2, {x: "100%"}, {
            x: "0%",
            delay: .7,
            force3d: false,
            ease: Sine.easeOut
        });
        let a_wd_4 = TweenMax.fromTo(this.animatedElems.emailWebDeveloper, 1.2, {x: "100%"}, {
            x: "0%",
            delay: .7,
            force3d: false,
            ease: Sine.easeOut
        });
        this.tl_homepage.add([a_wd_1, a_wd_2, a_wd_3, a_wd_4], "anim_web-developer");


        // -------------------
        // anim | slice of img (light version) sliding from the right
        this.tl_homepage.add("anim_panel-slide", 1.2);
        let arrayTweenAnimsIntro = this.tweens_getAnimPanelsRight();

        let t_2 = TweenMax.fromTo(this.animatedElems.imgSlideLight, 1.3, {left: "-100%"}, {
            left: "100%",
            ease: Sine.easeOut,
            onComplete(){
                _this.animatedElems.imgSlideLight.remove();
            }
        });
        let t_3 = TweenMax.fromTo(this.animatedElems.imgSlideLight2, 1.2, {left: "-100%"}, {
            left: "35%",
            delay: 1.3,
            ease: Sine.easeOut,
            onComplete(){
                _this.isTiltImgActivated = true;
            }
        });
        arrayTweenAnimsIntro.push(t_2);
        arrayTweenAnimsIntro.push(t_3);

        this.tl_homepage.add(arrayTweenAnimsIntro, "anim_panel-slide");
    }

    tweens_getAnimPanelsRight() {
        let arrayTweens = [];

        for (let i = 0; i < 5; i++) {
            let elem = jQuery('[img-slide-' + (i + 1) + ']', this.elRef.nativeElement);
            let tween = TweenMax.fromTo(elem, 1.3, {left: "100%"}, {
                left: "-100%",
                delay: (i * .3),
                ease: Sine.easeOut,
                onComplete(){
                    elem.remove();
                }
            });

            arrayTweens.push(tween);
        }

        return arrayTweens;
    }
}



// WEBPACK FOOTER //
// /Users/davidlagace/Sites/david-lagace-website/src/app/home/home.component.ts